var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draggableContainer"},_vm._l((_vm.widgets),function(widget,key){return (~_vm.widgetsInEditMode.indexOf(widget['.key']))?_c('Draggable',{key:key,attrs:{"widget":widget}}):_vm._e()}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a47da8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WidgetsEdit/index.vue
// module id = null
// module chunks = 